'use client';

import React from 'react';

import { type AbstractIntlMessages, NextIntlClientProvider } from 'next-intl';

import { getMessageFallback, handleNextIntlError } from './helpers';

type Props = {
  children: React.ReactNode;
  messages: Record<string, string | AbstractIntlMessages>;
};

export function LanguageProvider({ children, messages }: Props) {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const locale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;

  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      getMessageFallback={getMessageFallback}
      onError={handleNextIntlError}
      timeZone={timeZone}
    >
      {children}
    </NextIntlClientProvider>
  );
}
